/*
 * AL DAR OPTICS - Shopify Theme JS
 * Vanilla, no dependencies. Self-contained.
 */

(function() {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function() {

    // ===== Sticky header =====
    var header = document.getElementById('header');
    if (header) {
      window.addEventListener('scroll', function() {
        header.classList.toggle('scrolled', window.scrollY > 8);
      }, { passive: true });
    }

    // ===== Mobile drawer =====
    var drawer = document.getElementById('drawer');
    var menuToggle = document.getElementById('menuToggle');
    var drawerClose = document.getElementById('drawerClose');
    if (menuToggle && drawer) {
      menuToggle.addEventListener('click', function() {
        drawer.classList.add('open');
        document.body.style.overflow = 'hidden';
      });
    }
    if (drawerClose && drawer) {
      drawerClose.addEventListener('click', function() {
        drawer.classList.remove('open');
        document.body.style.overflow = '';
      });
    }
    if (drawer) {
      drawer.addEventListener('click', function(e) {
        if (e.target === drawer) {
          drawer.classList.remove('open');
          document.body.style.overflow = '';
        }
      });
    }

    // ===== Hero slider =====
    var slides = document.querySelectorAll('.hero-slide');
    var dots = document.querySelectorAll('.hero-dot');
    var heroNext = document.getElementById('heroNext');
    var heroPrev = document.getElementById('heroPrev');
    var current = 0;
    var autoplay;

    function goTo(i) {
      if (!slides.length) return;
      slides[current].classList.remove('active');
      if (dots[current]) dots[current].classList.remove('active');
      current = (i + slides.length) % slides.length;
      slides[current].classList.add('active');
      if (dots[current]) dots[current].classList.add('active');
    }
    function nextSlide() { goTo(current + 1); }
    function prevSlide() { goTo(current - 1); }
    function startAuto() { autoplay = setInterval(nextSlide, 6000); }
    function stopAuto() { clearInterval(autoplay); }
    function restartAuto() { stopAuto(); startAuto(); }

    if (slides.length > 1) {
      if (heroNext) heroNext.addEventListener('click', function() { nextSlide(); restartAuto(); });
      if (heroPrev) heroPrev.addEventListener('click', function() { prevSlide(); restartAuto(); });
      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() { goTo(i); restartAuto(); });
      });

      // Mobile swipe: left = next, right = previous. Ignores vertical scrolling.
      var heroTrack = document.getElementById('heroSlider');
      if (heroTrack) {
        var swipeX = null, swipeY = null;
        heroTrack.addEventListener('touchstart', function(e) {
          var t = e.changedTouches[0]; swipeX = t.clientX; swipeY = t.clientY;
        }, { passive: true });
        heroTrack.addEventListener('touchend', function(e) {
          if (swipeX === null) return;
          var t = e.changedTouches[0];
          var dx = t.clientX - swipeX, dy = t.clientY - swipeY;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
            if (dx < 0) { nextSlide(); } else { prevSlide(); }
            restartAuto();
          }
          swipeX = swipeY = null;
        }, { passive: true });
      }

      startAuto();
    }

    // ===== Announcement rotation =====
    var msgEl = document.getElementById('announceMsg');
    var announcementItems = document.querySelectorAll('.announce-msg [data-announce-text]');
    if (msgEl && announcementItems.length > 1) {
      var msgIndex = 0;
      var messages = [];
      announcementItems.forEach(function(el) { messages.push(el.innerHTML); });
      setInterval(function() {
        msgIndex = (msgIndex + 1) % messages.length;
        msgEl.style.opacity = 0;
        setTimeout(function() {
          msgEl.innerHTML = messages[msgIndex];
          msgEl.style.opacity = 1;
        }, 300);
      }, 5500);
    }

    // ===== Best sellers carousel (one product per arrow click) =====
    function initBestCarousel() {
      var carousel = document.getElementById('bestCarousel');
      var cPrev = document.getElementById('carouselPrev');
      var cNext = document.getElementById('carouselNext');
      if (!carousel || carousel.dataset.carouselBound) return;
      carousel.dataset.carouselBound = 'true';

      function step() {
        var card = carousel.querySelector('.product');
        if (!card) return 300;
        var styles = window.getComputedStyle(carousel);
        var gap = parseFloat(styles.columnGap || styles.gap) || 24;
        return card.getBoundingClientRect().width + gap;
      }
      function atEnd() {
        return carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 2;
      }
      function goNext() {
        if (atEnd()) {
          carousel.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          carousel.scrollBy({ left: step(), behavior: 'smooth' });
        }
      }
      function goPrev() {
        carousel.scrollBy({ left: -step(), behavior: 'smooth' });
      }
      if (cNext) cNext.addEventListener('click', function() { goNext(); restartBestAuto(); });
      if (cPrev) cPrev.addEventListener('click', function() { goPrev(); restartBestAuto(); });

      // ===== Autoplay: advance one product every few seconds =====
      var bestAutoTimer = null;
      var BEST_AUTO_DELAY = 2000;
      function startBestAuto() {
        stopBestAuto();
        bestAutoTimer = setInterval(goNext, BEST_AUTO_DELAY);
      }
      function stopBestAuto() {
        if (bestAutoTimer) { clearInterval(bestAutoTimer); bestAutoTimer = null; }
      }
      function restartBestAuto() {
        stopBestAuto();
        startBestAuto();
      }
      // Only pause while the user is actively dragging/scrolling the strip
      // itself (not on hover/tap — synthetic "mouseenter" after a tap on
      // touch devices would otherwise pause it forever with no matching
      // "mouseleave" to resume it).
      var resumeTimer = null;
      carousel.addEventListener('scroll', function() {
        stopBestAuto();
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(startBestAuto, 1800);
      }, { passive: true });
      startBestAuto();
    }
    initBestCarousel();
    // Re-bind when the Theme Editor re-renders the section (otherwise arrows die in the customizer)
    document.addEventListener('shopify:section:load', initBestCarousel);

    // ===== Filter chips =====
    document.querySelectorAll('.filter-chip-group').forEach(function(group) {
      group.querySelectorAll('.filter-chip').forEach(function(chip) {
        chip.addEventListener('click', function(e) {
          if (chip.tagName === 'A' && chip.getAttribute('href')) return; // let real links work
          e.preventDefault();
          group.querySelectorAll('.filter-chip').forEach(function(c) { c.classList.remove('active'); });
          chip.classList.add('active');
        });
      });
    });

    // ===== Wishlist toggle + Quick add (delegated so AJAX-injected cards work too) =====
    document.addEventListener('click', function(e) {
      var fav = e.target.closest('[data-wishlist]');
      if (fav) {
        e.preventDefault();
        e.stopPropagation();
        if (window.AldarWishlist) window.AldarWishlist.toggle(fav.getAttribute('data-wishlist'));
        return;
      }
      var btn = e.target.closest('.product-quick[data-variant-id]');
      if (!btn || btn.classList.contains('is-loading')) return;
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      var originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.classList.add('is-loading');

      window.AldarCart.add(variantId, 1).then(function() {
        btn.textContent = '✓ Added';
        btn.style.background = 'var(--success)';
        window.AldarCart.refreshBadge();
        setTimeout(function() {
          btn.textContent = originalText;
          btn.style.background = '';
          btn.classList.remove('is-loading');
        }, 1400);
      }).catch(function() {
        btn.textContent = 'Error';
        setTimeout(function() {
          btn.textContent = originalText;
          btn.classList.remove('is-loading');
        }, 1400);
      });
    });

    // ===== Reveal on scroll =====
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
      document.querySelectorAll('.reveal').forEach(function(el) { io.observe(el); });
    } else {
      document.querySelectorAll('.reveal').forEach(function(el) { el.classList.add('in'); });
    }

    // ===== Quantity steppers =====
    document.querySelectorAll('[data-qty-stepper]').forEach(function(stepper) {
      var input = stepper.querySelector('input[type="number"]');
      var minus = stepper.querySelector('[data-qty-minus]');
      var plus = stepper.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', function(e) {
        e.preventDefault();
        var v = parseInt(input.value, 10) || 1;
        if (v > parseInt(input.min || 1, 10)) input.value = v - 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      if (plus) plus.addEventListener('click', function(e) {
        e.preventDefault();
        var v = parseInt(input.value, 10) || 1;
        input.value = v + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // ===== Predictive search (basic) =====
    var searchInput = document.querySelector('[data-predictive-search-input]');
    var searchResults = document.querySelector('[data-predictive-search-results]');
    if (searchInput && searchResults) {
      var debounceTimer;
      searchInput.addEventListener('input', function() {
        clearTimeout(debounceTimer);
        var q = searchInput.value.trim();
        if (q.length < 2) {
          searchResults.innerHTML = '';
          searchResults.classList.remove('open');
          return;
        }
        debounceTimer = setTimeout(function() {
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
            .then(function(r) { return r.json(); })
            .then(function(data) {
              var products = (data.resources && data.resources.results && data.resources.results.products) || [];
              if (products.length === 0) {
                searchResults.innerHTML = '<div class="predictive-empty">No matches for "' + q + '"</div>';
              } else {
                searchResults.innerHTML = products.map(function(p) {
                  return '<a href="' + p.url + '" class="predictive-item">' +
                    (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') +
                    '<div><div class="predictive-title">' + p.title + '</div>' +
                    '<div class="predictive-price">' + p.price + '</div></div></a>';
                }).join('');
              }
              searchResults.classList.add('open');
            }).catch(function() {});
        }, 200);
      });
      document.addEventListener('click', function(e) {
        if (!searchResults.contains(e.target) && e.target !== searchInput) {
          searchResults.classList.remove('open');
        }
      });
    }

  });

  // ===== Cart AJAX helpers =====
  window.AldarCart = {
    add: function(variantId, quantity, properties) {
      var payload = { id: variantId, quantity: quantity || 1 };
      if (properties) payload.properties = properties;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function(r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      });
    },
    state: function() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r) { return r.json(); });
    },
    update: function(updates) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function(r) { return r.json(); });
    },
    change: function(line, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function(r) { return r.json(); });
    },
    clear: function() {
      return fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } }).then(function(r) { return r.json(); });
    },
    refreshBadge: function() {
      this.state().then(function(cart) {
        var badges = document.querySelectorAll('[data-cart-count]');
        badges.forEach(function(b) {
          b.textContent = cart.item_count;
          b.classList.toggle('is-empty', cart.item_count === 0);
        });
      });
    }
  };

})();

/*
 * ===== v2.0.4 modules =====
 * Money formatting, PDP variant sync, gallery, tabs, sticky bar,
 * related products (AJAX section rendering). No dependencies.
 */
(function() {
  'use strict';

  // ----- Money formatting (reads shop money format from <body data-money-format>) -----
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    format = format || (document.body.getAttribute('data-money-format') || 'QAR {{amount}}');

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    switch (format.match(placeholderRegex) ? format.match(placeholderRegex)[1] : 'amount') {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }
  window.AldarMoney = formatMoney;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function() {

    // ================= PDP module =================
    var section = document.getElementById('ProductSection');
    var jsonEl = document.querySelector('[data-product-json]');
    var form = document.querySelector('[data-product-form]');

    if (section && jsonEl && form) {
      var productData;
      try { productData = JSON.parse(jsonEl.textContent); } catch (err) { productData = null; }

      var idInput = form.querySelector('[data-variant-id]');
      var priceEl = section.querySelector('[data-price]');
      var compareEl = section.querySelector('[data-compare]');
      var saveEl = section.querySelector('[data-save]');
      var badgeSale = section.querySelector('[data-badge-sale]');
      var atc = form.querySelector('[data-atc]');
      var atcLabel = form.querySelector('[data-atc-label]');
      var atcPrice = form.querySelector('[data-atc-price]');
      var mainImage = section.querySelector('[data-main-image]');
      var paylaterWrap = section.querySelector('[data-paylater-wrap]');
      var bar = document.querySelector('[data-pdp-bar]');
      var barPrice = bar ? bar.querySelector('[data-bar-price]') : null;
      var barAtc = bar ? bar.querySelector('[data-bar-atc]') : null;

      function selectedOptions() {
        var values = [];
        section.querySelectorAll('.pdp-variant').forEach(function(group) {
          if (group.hasAttribute('data-eye-block') || group.classList.contains('lens-eye-block')) return;
          var sel = group.querySelector('select[data-option-select]');
          if (sel) { values.push(sel.value); return; }
          var checked = group.querySelector('input[type="radio"]:checked');
          values.push(checked ? checked.value : null);
        });
        return values;
      }

      section.addEventListener('change', function(e) {
        var sel = e.target.closest('select[data-option-select]');
        if (!sel) return;
        var group = sel.closest('.pdp-variant');
        var strong = group && group.querySelector('[data-selected-value]');
        if (strong) strong.textContent = sel.value;
        var mirror = group && group.querySelector('[data-option-mirror]');
        if (mirror) mirror.value = sel.value;
        updateUI(findVariant(selectedOptions()));
      });

      function findVariant(values) {
        if (!productData || !productData.variants) return null;
        return productData.variants.find(function(v) {
          return values.every(function(val, i) {
            return val === null || v['option' + (i + 1)] === val;
          });
        }) || null;
      }

      function setMainImage(src) {
        if (mainImage && src) {
          mainImage.removeAttribute('srcset');
          mainImage.src = src;
        }
      }

      function updatePaylater(priceCents) {
        if (!paylaterWrap) return;
        var line = paylaterWrap.querySelector('.product-paylater');
        if (!line) return;
        var n = parseInt(paylaterWrap.getAttribute('data-installments'), 10) || 4;
        var per = Math.round(priceCents / n);
        line.innerHTML = '<span class="paylater-icon" aria-hidden="true">💳</span> or ' + n + ' × ' + formatMoney(per) + ' with PayLater';
      }

      function updateUI(variant) {
        if (!variant) {
          if (atc) { atc.disabled = true; }
          if (atcLabel) atcLabel.textContent = 'Unavailable';
          if (atcPrice) atcPrice.textContent = '';
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (compareEl) {
          compareEl.hidden = !onSale;
          compareEl.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
        }
        if (saveEl) {
          saveEl.hidden = !onSale;
          if (onSale) {
            var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
            saveEl.textContent = 'Save ' + pct + '%';
            if (badgeSale) { badgeSale.hidden = false; badgeSale.textContent = '-' + pct + '%'; }
          } else if (badgeSale) {
            badgeSale.hidden = true;
          }
        }
        if (atc) {
          atc.disabled = !variant.available;
          if (atcLabel) atcLabel.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
          if (atcPrice) atcPrice.textContent = variant.available ? ' — ' + formatMoney(variant.price) : '';
        }
        if (barPrice) barPrice.textContent = formatMoney(variant.price);
        var stockWrap = section.querySelector('[data-stock-status]');
        if (stockWrap) {
          stockWrap.setAttribute('data-in-stock', variant.available ? 'true' : 'false');
          var stockText = stockWrap.querySelector('[data-stock-text]');
          if (stockText) stockText.textContent = variant.available ? 'In Stock' : 'Out of Stock';
        }
        var skuEl = document.querySelector('[data-spec-sku]');
        if (skuEl) skuEl.textContent = variant.sku || '\u2014';
        if (barAtc) barAtc.disabled = !variant.available;
        if (variant.featured_image && variant.featured_image.src) setMainImage(variant.featured_image.src);
        updatePaylater(variant.price);

        // Update URL so refresh/share keeps the variant
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      // Option change: toggle active classes + resolve variant
      section.querySelectorAll('.pdp-variant').forEach(function(group) {
        group.addEventListener('change', function(e) {
          if (e.target.matches('input[type="radio"]')) {
            group.querySelectorAll('.swatch-lg, .size-btn').forEach(function(l) {
              var input = l.querySelector('input[type="radio"]');
              l.classList.toggle('active', !!(input && input.checked));
            });
            var strong = group.querySelector('[data-selected-value]');
            if (strong) strong.textContent = e.target.value;
            updateUI(findVariant(selectedOptions()));
          }
        });
      });

      // Gallery thumbs
      section.querySelectorAll('[data-thumb]').forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          section.querySelectorAll('[data-thumb]').forEach(function(t) { t.classList.remove('active'); });
          thumb.classList.add('active');
          setMainImage(thumb.getAttribute('data-full-src'));
        });
      });

      // Sticky bar: show once the buy area scrolls out of view
      if (bar && 'IntersectionObserver' in window) {
        var sentinel = form;
        var barIO = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            bar.classList.toggle('visible', show);
            bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          });
        }, { threshold: 0 });
        barIO.observe(sentinel);
      }
      if (barAtc) {
        barAtc.addEventListener('click', function() {
          var qtyInput = form.querySelector('input[name="quantity"]');
          var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
          var original = barAtc.textContent;
          barAtc.textContent = 'Adding...';
          window.AldarCart.add(idInput.value, qty).then(function() {
            barAtc.textContent = '✓ Added';
            window.AldarCart.refreshBadge();
            setTimeout(function() { barAtc.textContent = original; }, 1400);
          }).catch(function() {
            barAtc.textContent = original;
            form.submit();
          });
        });
      }
    }

    // ================= PDP tabs =================
    var tabsWrap = document.querySelector('[data-pdp-tabs]');
    if (tabsWrap) {
      var tabs = tabsWrap.querySelectorAll('.pdp-tab');
      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          tabs.forEach(function(t) {
            t.classList.remove('active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('active');
          tab.setAttribute('aria-selected', 'true');
          document.querySelectorAll('.pdp-tab-panel').forEach(function(p) { p.classList.remove('active'); });
          var target = document.getElementById(tab.getAttribute('data-tab-target'));
          if (target) target.classList.add('active');
        });
      });
    }

    // ================= Related products (AJAX section rendering) =================
    var related = document.querySelector('[data-related-url]');
    if (related) {
      fetch(related.getAttribute('data-related-url'))
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-related-url]');
          if (fresh && fresh.querySelector('.product')) {
            related.innerHTML = fresh.innerHTML;
            related.querySelectorAll('.reveal').forEach(function(el) { el.classList.add('in'); });
          } else {
            var sectionEl = related.closest('.related-section');
            if (sectionEl) sectionEl.remove();
          }
        })
        .catch(function() {});
    }
  });
})();

/* ===== v2.0.5: PDP image zoom + Recently Viewed ===== */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* --- Cursor-follow zoom on the PDP main image (fine pointers only) --- */
  function initZoom() {
    var wrap = document.querySelector('.pdp-main-image[data-zoom="true"]');
    if (!wrap || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var img = wrap.querySelector('img');
    if (!img) return;

    function setOrigin(e) {
      var r = wrap.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      img.style.transformOrigin = x.toFixed(1) + '% ' + y.toFixed(1) + '%';
    }
    wrap.addEventListener('click', function (e) {
      setOrigin(e);
      wrap.classList.toggle('zoomed');
    });
    wrap.addEventListener('mousemove', function (e) {
      if (wrap.classList.contains('zoomed')) setOrigin(e);
    });
    wrap.addEventListener('mouseleave', function () {
      wrap.classList.remove('zoomed');
      img.style.transformOrigin = '';
    });
  }

  /* --- Recently viewed: record handle, then hydrate the section via the
         Section Rendering API on the search route --- */
  var RV_KEY = 'aldar:recently-viewed';

  function readHistory() {
    try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; }
    catch (e) { return []; }
  }

  function currentHandle() {
    var el = document.querySelector('[data-product-json]');
    if (!el) return null;
    try { return (JSON.parse(el.textContent) || {}).handle || null; }
    catch (e) { return null; }
  }

  function recordVisit(handle) {
    if (!handle) return;
    var list = readHistory().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12))); }
    catch (e) { /* storage unavailable — degrade silently */ }
  }

  function hydrateRecentlyViewed(handle) {
    var section = document.querySelector('[data-recently-viewed]');
    if (!section) return;
    var limit = parseInt(section.getAttribute('data-limit'), 10) || 4;
    var handles = readHistory()
      .filter(function (h) { return h !== handle; })
      .slice(0, limit);
    if (!handles.length) return; // stays hidden

    var q = handles.map(function (h) { return 'handle:' + h; }).join(' OR ');
    var url = section.getAttribute('data-search-url') +
      '?section_id=' + encodeURIComponent(section.getAttribute('data-section-id')) +
      '&type=product&q=' + encodeURIComponent(q);

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('[data-recently-viewed-grid]');
        var target = section.querySelector('[data-recently-viewed-grid]');
        if (!grid || !target || !grid.querySelector('.product')) return;
        target.innerHTML = grid.innerHTML;

        // Restore most-recent-first order (search does not preserve it)
        handles.forEach(function (h) {
          var card = target.querySelector('a[href*="/products/' + h + '"]');
          var product = card && card.closest('.product');
          if (product) target.appendChild(product);
        });

        target.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
        section.removeAttribute('hidden');
      })
      .catch(function () { /* leave hidden on failure */ });
  }

  ready(function () {
    initZoom();
    var handle = currentHandle();
    hydrateRecentlyViewed(handle); // hydrate from history *before* adding current
    recordVisit(handle);
  });
})();


/* ===== v2.1.1: persistent wishlist (localStorage) ===== */
(function () {
  'use strict';
  var KEY = 'aldar:wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* ignore */ }
  }
  function paint() {
    var list = read();
    document.querySelectorAll('[data-wishlist]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-wishlist')) !== -1;
      btn.classList.toggle('active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  window.AldarWishlist = {
    list: read,
    toggle: function (handle) {
      if (!handle) return;
      var list = read();
      var i = list.indexOf(handle);
      if (i === -1) list.unshift(handle); else list.splice(i, 1);
      write(list.slice(0, 100));
      paint();
    }
  };

  if (document.readyState !== 'loading') paint();
  else document.addEventListener('DOMContentLoaded', paint);

  new MutationObserver(function () { paint(); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();

/* ===== v2.1.6: wishlist page hydration ===== */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var page = document.querySelector('[data-wishlist-page]');
    if (!page || !window.AldarWishlist) return;
    var grid = page.querySelector('[data-wishlist-grid]');
    var empty = page.querySelector('[data-wishlist-empty]');

    function showEmpty(isEmpty) {
      if (empty) empty.hidden = !isEmpty;
      if (grid) grid.hidden = isEmpty;
    }

    var handles = window.AldarWishlist.list().slice(0, 24);
    if (!handles.length) { showEmpty(true); return; }

    var q = handles.map(function (h) { return 'handle:' + h; }).join(' OR ');
    var url = page.getAttribute('data-search-url') +
      '?section_id=' + encodeURIComponent(page.getAttribute('data-section-id')) +
      '&type=product&q=' + encodeURIComponent(q);

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-wishlist-grid]');
        if (!fresh || !fresh.querySelector('.product')) { showEmpty(true); return; }
        grid.innerHTML = fresh.innerHTML;

        // saved order: most recently hearted first
        handles.forEach(function (h) {
          var a = grid.querySelector('a[href*="/products/' + h + '"]');
          var card = a && a.closest('.product');
          if (card) grid.appendChild(card);
        });
        grid.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
        showEmpty(false);
      })
      .catch(function () { showEmpty(true); });

    // Un-hearting a card on this page removes it from the grid
    page.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist]');
      if (!btn) return;
      // let the global toggle run first, then reconcile
      setTimeout(function () {
        var list = window.AldarWishlist.list();
        if (list.indexOf(btn.getAttribute('data-wishlist')) === -1) {
          var card = btn.closest('.product');
          if (card) card.remove();
          if (!grid.querySelector('.product')) showEmpty(true);
        }
      }, 0);
    });
  });
})();


/* ===== v2.5.0: contact-lens per-eye prescription panel ===== */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('.pdp-delivery').forEach(function (row) {
      var days = parseInt(row.getAttribute('data-delivery-days'), 10) || 2;
      var d = new Date();
      d.setDate(d.getDate() + days);
      var el = row.querySelector('[data-delivery-date]');
      if (el) el.textContent = d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
    });

    var wrap = document.querySelector('[data-lens-eyes]');
    var form = document.querySelector('[data-product-form]');
    var jsonEl = document.querySelector('[data-product-json]');
    if (!wrap || !form || !jsonEl) return;

    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var same = wrap.querySelector('[data-lens-same]');
    var payBtn = form.querySelector('.shopify-payment-button');
    if (payBtn) payBtn.style.display = 'none'; // multi-line orders go through the cart

    function eyeSelects(side) {
      return Array.prototype.slice.call(wrap.querySelectorAll('select[data-eye-opt="' + side + '"]'))
        .sort(function (a, b) { return a.getAttribute('data-opt-index') - b.getAttribute('data-opt-index'); });
    }
    function eyeValues(side) { return eyeSelects(side).map(function (s) { return s.value; }); }
    function findVariant(values) {
      return (product.variants || []).find(function (v) {
        return [v.option1, v.option2, v.option3].slice(0, values.length)
          .every(function (o, i) { return o === values[i]; });
      });
    }
    function copyLeftToRight() {
      var L = eyeValues('left');
      eyeSelects('right').forEach(function (s, i) { s.value = L[i]; });
    }
    function applySame() {
      var on = same && same.checked;
      eyeSelects('right').forEach(function (s) { s.disabled = !!on; });
      if (on) copyLeftToRight();
    }
    if (same) same.addEventListener('change', applySame);
    wrap.addEventListener('change', function (e) {
      if (same && same.checked && e.target.closest('[data-eye-opt="left"]')) copyLeftToRight();
    });
    applySame();

    form.addEventListener('submit', function (e) {
      if (!window.AldarCart) return;
      e.preventDefault();
      var atc = form.querySelector('[data-atc]');
      var jobs = [], problems = [];
      ['left', 'right'].forEach(function (side) {
        var qty = parseInt((wrap.querySelector('[data-eye-qty="' + side + '"]') || {}).value, 10) || 0;
        if (qty < 1) return;
        var v = findVariant(eyeValues(side));
        var label = side === 'left' ? 'Left eye' : 'Right eye';
        if (!v) { problems.push(label + ': combination unavailable'); return; }
        if (!v.available) { problems.push(label + ': out of stock'); return; }
        jobs.push({ id: v.id, qty: qty, eye: label.split(' ')[0] });
      });
      if (problems.length) {
        if (atc) { var keep = atc.innerHTML; atc.textContent = problems[0]; setTimeout(function () { atc.innerHTML = keep; }, 2400); }
        return;
      }
      if (!jobs.length) {
        if (atc) { var k2 = atc.innerHTML; atc.textContent = 'Set a quantity for at least one eye'; setTimeout(function () { atc.innerHTML = k2; }, 2200); }
        return;
      }
      var chain = Promise.resolve();
      jobs.forEach(function (job) {
        chain = chain.then(function () { return window.AldarCart.add(job.id, job.qty, { Eye: job.eye }); });
      });
      chain.then(function () {
        if (window.AldarCart.refreshBadge) window.AldarCart.refreshBadge();
        if (atc) { var prev = atc.innerHTML; atc.innerHTML = 'Added to Cart ✓'; setTimeout(function () { atc.innerHTML = prev; }, 2000); }
      }).catch(function () {
        if (atc) atc.textContent = 'Could not add — try again';
      });
    });
  });
})();

/* ===== v2.3.1: product share + popular searches ===== */
(function () {
  'use strict';

  // Share: native sheet where available, clipboard fallback with a tip
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share]');
    if (!btn) return;
    var payload = { title: btn.getAttribute('data-share-title') || document.title, url: window.location.href };
    if (navigator.share) {
      navigator.share(payload).catch(function () {});
      return;
    }
    var done = function () {
      var tip = btn.querySelector('[data-share-tip]');
      if (!tip) return;
      tip.hidden = false;
      setTimeout(function () { tip.hidden = true; }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(payload.url).then(done).catch(done);
    } else { done(); }
  });

  // Popular searches: shown when the search field is focused while empty
  var input = document.querySelector('[data-predictive-search-input]');
  var results = document.querySelector('[data-predictive-search-results]');
  if (!input || !results) return;

  function popularHTML() {
    var raw = results.getAttribute('data-popular') || '';
    var terms = raw.split('|').map(function (t) { return t.trim(); }).filter(Boolean);
    if (!terms.length) return '';
    var base = results.getAttribute('data-search-url') || '/search';
    return '<div class="predictive-popular"><div class="predictive-popular-title">Popular searches</div>' +
      terms.map(function (t) {
        return '<a class="predictive-popular-term" href="' + base + '?q=' + encodeURIComponent(t) + '">' + t + '</a>';
      }).join('') + '</div>';
  }

  function maybeShowPopular() {
    if (input.value.trim().length >= 2) return;
    var html = popularHTML();
    if (!html) return;
    results.innerHTML = html;
    results.classList.add('open');
  }

  input.addEventListener('focus', maybeShowPopular);
  input.addEventListener('input', function () {
    if (input.value.trim().length < 2) maybeShowPopular();
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.search-bar')) results.classList.remove('open');
  });
})();

/* ===== v2.3.4: collection browser (sidebar category selector) ===== */
(function () {
  'use strict';

  function initBrowsers() {
    document.querySelectorAll('[data-collection-browser]').forEach(function (root) {
      if (root.dataset.browserBound) return;
      root.dataset.browserBound = 'true';
      var tabs = root.querySelectorAll('[data-browser-tab]');
      var panels = root.querySelectorAll('[data-browser-panel]');
      var select = root.querySelector('[data-browser-select]');

      function activate(i) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-browser-tab') === String(i);
          t.classList.toggle('active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-browser-panel') !== String(i);
        });
        if (select && select.value !== String(i)) select.value = String(i);
        panels.forEach(function (p) {
          if (!p.hidden) p.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
        });
      }

      root.addEventListener('click', function (e) {
        var tab = e.target.closest('[data-browser-tab]');
        if (tab) activate(tab.getAttribute('data-browser-tab'));
      });
      if (select) select.addEventListener('change', function () { activate(select.value); });
      activate(0);
    });
  }
  if (document.readyState !== 'loading') initBrowsers();
  else document.addEventListener('DOMContentLoaded', initBrowsers);
  document.addEventListener('shopify:section:load', initBrowsers);
})();

/* ===== v2.3.9: PLP premium — view switcher, price slider, compare ===== */
(function () {
  'use strict';

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  // --- grid view switcher (2/3/4) ---
  function initSwitch() {
    var sw = document.querySelector('[data-grid-switch]');
    var grid = document.querySelector('.plp .product-grid');
    if (!sw || !grid || sw.dataset.bound) return;
    sw.dataset.bound = 'true';
    function apply(n) {
      grid.classList.remove('plp-grid--2', 'plp-grid--3', 'plp-grid--4');
      grid.classList.add('plp-grid--' + n);
      sw.querySelectorAll('[data-grid-cols]').forEach(function (b) {
        b.classList.toggle('active', b.getAttribute('data-grid-cols') === String(n));
      });
      try { localStorage.setItem('aldar:plpcols', n); } catch (e) {}
    }
    sw.addEventListener('click', function (e) {
      var b = e.target.closest('[data-grid-cols]');
      if (b) apply(b.getAttribute('data-grid-cols'));
    });
    var saved = '3';
    try { saved = localStorage.getItem('aldar:plpcols') || '3'; } catch (e) {}
    apply(saved);
  }

  // --- dual price slider, driving the existing min/max form fields ---
  function initSlider() {
    document.querySelectorAll('[data-price-slider]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = 'true';
      var lo = root.querySelector('[data-pps-min]');
      var hi = root.querySelector('[data-pps-max]');
      var fill = root.querySelector('[data-pps-fill]');
      var outLo = root.querySelector('[data-pps-min-out]');
      var outHi = root.querySelector('[data-pps-max-out]');
      var group = root.closest('.plp-filter-group');
      var inputs = group ? group.querySelectorAll('input[type="number"]') : [];
      var max = parseFloat(root.getAttribute('data-max')) || 100;
      function sync() {
        var a = Math.min(+lo.value, +hi.value), b = Math.max(+lo.value, +hi.value);
        if (outLo) outLo.textContent = 'QAR ' + a;
        if (outHi) outHi.textContent = 'QAR ' + b;
        if (fill) { fill.style.left = (a / max * 100) + '%'; fill.style.right = (100 - b / max * 100) + '%'; }
        if (inputs[0]) inputs[0].value = a || '';
        if (inputs[1]) inputs[1].value = b === max ? '' : b;
      }
      lo.addEventListener('input', sync);
      hi.addEventListener('input', sync);
      sync();
    });
  }

  // --- compare (localStorage, floating bar, hydrated overlay) ---
  var CKEY = 'aldar:compare';
  function clist() { try { return JSON.parse(localStorage.getItem(CKEY)) || []; } catch (e) { return []; } }
  function cset(v) { try { localStorage.setItem(CKEY, JSON.stringify(v.slice(0, 4))); } catch (e) {} paint(); bar(); }
  function paint() {
    var l = clist();
    document.querySelectorAll('[data-compare]').forEach(function (b) {
      b.setAttribute('aria-pressed', l.indexOf(b.getAttribute('data-compare')) > -1 ? 'true' : 'false');
    });
  }
  function bar() {
    var el = document.getElementById('aldarCompareBar');
    var l = clist();
    if (!l.length) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('div');
      el.id = 'aldarCompareBar';
      el.className = 'compare-bar';
      el.innerHTML = '<span data-cbar-count></span><button type="button" class="btn btn-brand" data-cbar-view>Compare</button><button type="button" class="cbar-clear" data-cbar-clear aria-label="Clear compare">&times;</button>';
      document.body.appendChild(el);
      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-cbar-clear]')) cset([]);
        if (e.target.closest('[data-cbar-view]')) overlay();
      });
    }
    el.querySelector('[data-cbar-count]').textContent = l.length + ' to compare';
  }
  function overlay() {
    var l = clist();
    if (!l.length) return;
    var q = l.map(function (h) { return 'handle:' + h; }).join(' OR ');
    fetch('/search?section_id=main-wishlist&type=product&q=' + encodeURIComponent(q))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('[data-wishlist-grid]');
        var ov = document.getElementById('aldarCompareOverlay');
        if (ov) ov.remove();
        ov = document.createElement('div');
        ov.id = 'aldarCompareOverlay';
        ov.className = 'compare-overlay';
        ov.innerHTML = '<div class="compare-panel"><div class="compare-head"><strong>Compare</strong><button type="button" class="drawer-close" data-cov-close aria-label="Close">&times;</button></div><div class="compare-grid product-grid">' + (grid ? grid.innerHTML : '') + '</div></div>';
        document.body.appendChild(ov);
        ov.querySelectorAll('.reveal').forEach(function (x) { x.classList.add('in'); });
        ov.addEventListener('click', function (e) {
          if (e.target === ov || e.target.closest('[data-cov-close]')) ov.remove();
        });
      });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-compare]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var h = b.getAttribute('data-compare');
    var l = clist();
    var i = l.indexOf(h);
    if (i > -1) l.splice(i, 1); else l.unshift(h);
    cset(l);
  }, true);

  ready(function () { initSwitch(); initSlider(); paint(); bar(); });
  document.addEventListener('shopify:section:load', function () { initSwitch(); initSlider(); paint(); });
})();


/* v2.5.0: sticky header stuck-state shadow */
(function () {
  var header = document.getElementById('header');
  if (!header || header.getAttribute('data-sticky') !== 'true') return;
  var on = false;
  function check() {
    var stuck = window.scrollY > 4;
    if (stuck !== on) { on = stuck; header.classList.toggle('is-stuck', stuck); }
  }
  window.addEventListener('scroll', check, { passive: true });
  check();
})();

/* v2.5.0 · 2) New In tabs — instant in-place switching */
(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
      if (tabs.dataset.bound) return;
      tabs.dataset.bound = 'true';
      var scope = tabs.closest('.container') || document;
      function activate(i) {
        tabs.querySelectorAll('[data-tab-btn]').forEach(function (b) {
          var on = b.getAttribute('data-tab-btn') === String(i);
          b.classList.toggle('active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        scope.querySelectorAll('[data-tab-panel]').forEach(function (p) {
          p.hidden = p.getAttribute('data-tab-panel') !== String(i);
          if (!p.hidden) p.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
        });
        var countEl = scope.querySelector('[data-tabs-count]');
        if (countEl) {
          var activePanel = scope.querySelector('[data-tab-panel]:not([hidden])');
          if (activePanel) countEl.textContent = 'Showing ' + activePanel.children.length + ' products';
        }
      }
      tabs.addEventListener('click', function (e) {
        var b = e.target.closest('[data-tab-btn]');
        if (b) activate(b.getAttribute('data-tab-btn'));
      });
      var firstTab = tabs.querySelector('[data-tab-btn]');
      if (firstTab) activate(firstTab.getAttribute('data-tab-btn'));
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

/* ===== v2.7.2: filters drawer + quick-links scroll arrow ===== */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-filters-open]');
    var close = e.target.closest('[data-filters-close]');
    var plp = document.querySelector('[data-plp]');
    if (!plp) return;
    var overlay = plp.querySelector('.plp-drawer-overlay');
    if (open) { plp.classList.add('filters-open'); if (overlay) overlay.hidden = false; document.documentElement.style.overflow = 'hidden'; }
    if (close) { plp.classList.remove('filters-open'); if (overlay) overlay.hidden = true; document.documentElement.style.overflow = ''; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var plp = document.querySelector('[data-plp].filters-open');
    if (!plp) return;
    plp.classList.remove('filters-open');
    var overlay = plp.querySelector('.plp-drawer-overlay');
    if (overlay) overlay.hidden = true;
    document.documentElement.style.overflow = '';
  });
  function initQlNext() {
    document.querySelectorAll('.quick-links-wrap').forEach(function (wrap) {
      var row = wrap.querySelector('.quick-links');
      var btn = wrap.querySelector('[data-ql-next]');
      if (!row || !btn || btn.dataset.bound) return;
      btn.dataset.bound = 'true';
      function fit() { btn.hidden = row.scrollWidth <= row.clientWidth + 4; }
      btn.addEventListener('click', function () { row.scrollBy({ left: 280, behavior: 'smooth' }); });
      window.addEventListener('resize', fit);
      fit();
    });
  }
  if (document.readyState !== 'loading') initQlNext();
  else document.addEventListener('DOMContentLoaded', initQlNext);
  document.addEventListener('shopify:section:load', initQlNext);
})();